/**
 * @generated SignedSource<<23fc1094ca7f48565f176a96bd8ccf47>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useRowColor_project">;
  readonly " $fragmentType": "row_nativeIssueTable_project";
};
export type row_nativeIssueTable_project$key = {
  readonly " $data"?: row_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useRowColor_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "20a65fa136750e5035b2ea870993c11a";

export default node;
